<template>

    <div class="container">
        <div class="register=form">
            <div class="main-div">
                <div class="panel"><h1>Register</h1></div>
                <form @submit="formSubmit" id="login">
                    <div class="form-group">
                        <label for="email">E-mail</label>
                        <input class="form-control"
                               id="email"
                               name="email"
                               placeholder="E-mail address"
                               required
                               type="email"
                               v-model="email">
                    </div>
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input class="form-control" id="password"
                               name="password"
                               placeholder="Password"
                               required
                               type="password"
                               v-model="password">
                    </div>
                    <div class="form-group">
                        <label for="rePassword">Retype password</label>
                        <input class="form-control" id="rePassword" name="rePassword"
                               placeholder="Retype password"
                               required
                               type="password">
                    </div>

                    <div class="row justify-content-center">
                        <button class="btn btn-primary" type="submit">Sign up</button>
                    </div>
                </form>
            </div>
        </div>

        <div class="row justify-content-center">
            <span class="font-medium">Already have an account? </span>
            <a class="normal"> Login here</a>
        </div>
    </div>

</template>

<script>
    export default {
        name: "RegisterPage",
        data() {
            return {
                email: '',
                password: ''
            }
        },
        methods: {
            formSubmit(e) {
                e.preventDefault();
                this.$http.post('auth/register', {
                    'email': this.email,
                    'password': this.password
                }).then(result => {
                    console.info("Success");
                    this.$router.push('/auth/login')
                }, error => {
                    console.error(error);
                });
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 600px;
    }

    .containfer {
        background: #f7f7f7 none repeat scroll 0 0;
        border: 1px solid #d4d4d4;
        border-radius: 4px;
        font-size: 14px;
        height: 50px;
        line-height: 50px;
    }

    .h3 {
        margin-bottom: 30px;
        margin-top: 25px;
        text-align: center;
        font-size: 35px;
    }

    .main-div {
        background: white none repeat scroll 0 0;
        border-radius: 20px;
        margin: 10px auto 30px;
        max-width: 100%;
        padding: 30px 30px 10px 30px;
    }

    .btn {
        margin-bottom: 35px;
        margin-top: 20px;
        margin-left: 125px;
        margin-right: 125px;
        width: 200px;
        height: 50px;
    }

    .justify-content-center {
        margin-bottom: 25px;
    }

    .form-control {
        background: #f7f7f7 none repeat scroll 0 0;
        border: 1px solid #d4d4d4;
        border-radius: 4px;
        font-size: 14px;
        height: 50px;
        line-height: 50px;
    }

</style>
